import { Controller } from '@hotwired/stimulus';

/**
 * Back Button Controller
 *
 * Simple controller to handle browser back navigation.
 * Uses window.history.back() which works perfectly on web
 * since the browser maintains its own history stack.
 *
 * Usage:
 * <a href="#" data-controller="back-button" data-action="click->back-button#goBack">
 *   <img src="back_icon.svg" alt="Back">
 *   <span>Go Back</span>
 * </a>
 */
export default class extends Controller {
  goBack(event) {
    event.preventDefault();
    window.history.back();
  }
}
